import { format } from "date-fns"
import React from "react"
import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { Controller, useFormContext } from "react-hook-form"
import InputBox from "./InputBox"

const DatePicker = ({
  name,
  label,
  selectedDate,
  setSelectedDate,
  boxClassName,
  defaultValue,
  minDate,
  maxDate
}) => {
  let startDate = new Date()
  startDate.setDate(startDate.getDate() + 1)
  let endDate = new Date()
  if(minDate || minDate === null){
    startDate = minDate
  }
 
  if(maxDate || maxDate === null){
    endDate = maxDate
  }
  if(minDate == undefined && maxDate == undefined){
    endDate = null;
  }

  const formatDate = (dateProp) => format(dateProp, "MM/dd/yyyy")

  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <InputBox
      name={name}
      label={label}
      errors={errors}
      className={boxClassName}
    >
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field }) => (
          <ReactDatePicker
            selected={selectedDate}
            onChange={(dateProp) => {
              setSelectedDate(dateProp)
              field.onChange(formatDate(dateProp))
            }}
            name={name}
            dateFormat="dd/MM/yyyy"
            minDate={startDate}
            maxDate={endDate}
          />
        )}
      />
    </InputBox>
  )
}

export default DatePicker
